import { ProductModel } from '../../models';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Angular2
import { Inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { Config, WEB_CONFIG } from '../../config';
import { catchError } from 'rxjs/operators';
import { PurchaseOrderModel } from '../../models';
import { CookieService } from 'ngx-cookie-service';
import { JwtHelper } from '../jwt-security/jwt.helpher';


const TOKEN_NAME = 'authToken';
const SECONDARY_TOKEN_NAME = 'authTokenSecondary';

@Injectable()
export class CommonApiService {

  public headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json'
  });

  public jwtHelper =  new JwtHelper();

  constructor(
    @Inject(WEB_CONFIG) private config: Config,
    private cookieService: CookieService,
    private http: HttpClient
  ) {}

  public static handleError(error) {
    return throwError(error || 'api error');
  }

  // Global product search
  public getProductGlobalSearch(
    searchInput: string,
    language: string
  ): Observable<ProductModel[]> {
    return this.http
      .get<ProductModel[]>(
        this.config.api_url +
          '/video-api/products/globalSearch?searchInput=' +
          searchInput +
          '&language=' +
          language
      )
      .pipe(catchError(CommonApiService.handleError));
  }

  public getPurchaseOrderByGlobalSearch(
    searchInput: string,
    language: string
  ): Observable<PurchaseOrderModel[]> {
    return this.http
      .get<PurchaseOrderModel[]>(
        this.config.api_url +
          '/video-api/purchaseOrders/globalSearch?searchInput=' +
          searchInput +
          '&language=' +
          language
      )
      .pipe(catchError(CommonApiService.handleError));
  }

  public setToken(token: string): void {
    sessionStorage.removeItem(TOKEN_NAME);
    sessionStorage.setItem(TOKEN_NAME, token);
  }

  public setSecondaryToken(token: string): void {
    sessionStorage.removeItem(SECONDARY_TOKEN_NAME);
    sessionStorage.setItem(SECONDARY_TOKEN_NAME, token);
  }

  getToken() {
    const user = this.decodeToken(TOKEN_NAME);
    if (user && user.superAdmin && sessionStorage.hasOwnProperty(SECONDARY_TOKEN_NAME)) {
      return sessionStorage.getItem(SECONDARY_TOKEN_NAME);
    }

    return sessionStorage.getItem(TOKEN_NAME);
  }

  public decodeToken(tokenName: string) {
    return sessionStorage.hasOwnProperty(tokenName) ? this.jwtHelper.decodeToken(sessionStorage.getItem(tokenName)) : {};
  }

  public getUserDataFromToken(): any {
    const user = this.decodeToken(TOKEN_NAME);

    if (user && user.superAdmin && sessionStorage.hasOwnProperty(SECONDARY_TOKEN_NAME)) {
      return  Object.assign({ secondary: true }, this.decodeToken(SECONDARY_TOKEN_NAME));
    }

    return user;
  }

  public isTokenValid() {
    let payload: any;
    try {
      payload = this.getUserDataFromToken();
    } catch (e) {
      payload = {};
    }

    if (!payload.exp) {
      return false;
    }

    return payload.exp * 1000 > Date.now();
  }

  public ssoLogin(email: string): Observable<any> {
    const url: string = this.config.api_url + '/authorization-api/login/email';

    return this.http
      .post(url, email, {headers: this.headers})
      .pipe(catchError(CommonApiService.handleError));
  }
}
